module.exports = __webpack_public_path__ + "img/slide5-ru.e7cf5781.png";